import React from 'react';
import { Link } from 'react-router-dom';

interface AmbassadorBadgeProps {
  size?: 'sm' | 'md';
  linked?: boolean;
}

export function AmbassadorBadge({ size = 'sm', linked = true }: AmbassadorBadgeProps) {
  const badge = (
    <span
      className={`inline-flex items-center gap-1 rounded-full bg-brand-100 text-brand-700 font-medium ${
        size === 'sm' ? 'px-2 py-0.5 text-xs' : 'px-3 py-1 text-sm'
      }`}
      title="xrp.deals Ambassador"
    >
      <svg width={size === 'sm' ? 12 : 14} height={size === 'sm' ? 12 : 14} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M8 1L10.163 5.279L15 6.056L11.5 9.321L12.326 14L8 11.779L3.674 14L4.5 9.321L1 6.056L5.837 5.279L8 1Z" fill="currentColor" />
      </svg>
      Ambassador
    </span>
  );

  if (linked) {
    return <Link to="/ambassadors">{badge}</Link>;
  }

  return badge;
}
